import { Component, ReactElement } from 'react';
import './checkbox.scss';

interface CheckboxProps {
    checked: boolean;
    onChange: (value: boolean, e?: MouseEvent) => void;
    checkboxTitle?: string;
    isDisabled?: boolean;
    tooltip?: string | ReactElement;
    extraClassname?: string;
    inputIds?: string;
    onClick?: (e: MouseEvent) => void;
    name?: string;
}

interface CheckboxState {}

export class Checkbox extends Component<CheckboxProps, CheckboxState> {
    render() {
        return <div />;
    }
}
